import React from "react"
import { BoxWrapper, RelatedCaseStudies } from "components"
import { RelatedCaseStudiesWrapper } from "./style"

const CaseStudies = ({
  boxWrapperProps,
  realtedCaseStudiesProps,
}: ICaseStudiesInteriorContainerProps) => {
  return (
    <BoxWrapper {...boxWrapperProps}>
      <RelatedCaseStudiesWrapper>
        <RelatedCaseStudies {...realtedCaseStudiesProps} />
      </RelatedCaseStudiesWrapper>
    </BoxWrapper>
  )
}

export default CaseStudies
